import { render, staticRenderFns } from "./CoverEditView.vue?vue&type=template&id=82f00dc4&scoped=true&"
import script from "./CoverEditView.vue?vue&type=script&lang=js&"
export * from "./CoverEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f00dc4",
  null
  
)

export default component.exports